import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'state'
import useIsWindowVisible from 'hooks/useIsWindowVisible'
import { getRpcProvider } from 'utils/providers'
import { setBlock } from '.'
import { State } from '../types'
import useActiveWeb3React from '../../hooks/useActiveWeb3React'

export const usePollBlockNumber = () => {
  const { chainId } = useActiveWeb3React()
  const timer = useRef(null)
  const dispatch = useAppDispatch()
  const isWindowVisible = useIsWindowVisible()

  useEffect(() => {
    if (isWindowVisible && window.ethereum) {
      timer.current = setInterval(async () => {
        const provider = await getRpcProvider(chainId)
        if (provider) {
          const blockNumber = await provider.getBlockNumber()
          dispatch(setBlock(blockNumber))
        }
      }, 6000)
    } else {
      clearInterval(timer.current)
    }

    return () => clearInterval(timer.current)
  }, [chainId, dispatch, timer, isWindowVisible])
}

export const useBlock = () => {
  return useSelector((state: State) => state.block)
}

export const useInitialBlock = () => {
  return useSelector((state: State) => state.block.initialBlock)
}
